import Permissions from '@/app/permissions/Permissions';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

const PUSH_PAYMENTS_TABS = {
    PARTNERS:
    {
        name: 'partners',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.PUSH_PAYMENT_READ.name] })
    },
    NOTIF_RULES:
    {
        name: 'notif_rules',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.PUSH_PAYMENT_READ.name] })
    }
};

PUSH_PAYMENTS_TABS.DEFAULT = PUSH_PAYMENTS_TABS.PARTNERS;

export default PUSH_PAYMENTS_TABS;